<template>
    <CustomMarker
        v-if="hasValidCoordinates"
        :options="{
            position: { lat: latitude, lng: longitude },
            anchorPoint: 'CENTER',
        }">
        <!-- Named for the site so the pin is not an anonymous image. The
             padding grows the tap target to 44px without changing the pin's
             drawn size; the CENTER anchor keeps it centred on the point. -->
        <img v-show="active" class="pin pin-active" src="/img/marker.svg" width="35" height="42" :alt="name" />
        <img v-show="!active" class="pin pin-inactive" src="/img/marker.svg" width="22" height="22" :alt="name" />
    </CustomMarker>
</template>

<script setup>
    import { CustomMarker } from 'vue3-google-map';

    const props = defineProps({
        marker: {
            type: Object,
            required: true,
        },
        active: {
            type: Boolean,
            required: false,
        },
    });

    import { computed } from 'vue';

    const name = computed(() => itemDisplayName(props.marker?.fields ? props.marker : props.marker?.value));

    // #TODO: turn this coordinates fetching into a composable or whatever.
    const coordinates = computed(() => props.marker?.fields?.['Geocoordinates'] || props.marker?.value?.fields?.['Geocoordinates'] || '');

    const latitude = computed(() => {
        if (!coordinates.value) return 0;
        const lat = coordinates.value.split(',')[0]?.trim();
        const parsed = parseFloat(lat);
        return isNaN(parsed) ? 0 : parsed;
    });

    const longitude = computed(() => {
        if (!coordinates.value) return 0;
        const lng = coordinates.value.split(',')[1]?.trim();
        const parsed = parseFloat(lng);
        return isNaN(parsed) ? 0 : parsed;
    });

    const hasValidCoordinates = computed(() => {
        return coordinates.value && 
               !isNaN(latitude.value) && 
               !isNaN(longitude.value) &&
               latitude.value !== 0 &&
               longitude.value !== 0;
    });
</script>

<style lang="scss" scoped>
    .pin {
        box-sizing: content-box;
        cursor: pointer;
    }

    .pin-inactive {
        padding: 11px;
    }

    .pin-active {
        padding: 1px 5px;
    }

    .global-marker {
        // &.active {
        // 	z-index: 9;
        // }
    }
</style>
